export const materialModalstyle = {
  width: "fit-content",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: 3,
  boxShadow: 24,
  display: "block",
  overflowX: "hidden",
}
